<template>
    <div>

        <div class="text-center mb-4">

            <div class="form-group btn-group btn-group-sm btn-group-toggle">
                <span class="btn btn-sm btn-outline-secondary">
                    <input type="radio" :value="null" v-model="filters.selected.type" id="filter-type-null" @change="getSorts()">
                    <label for="filter-type-null">Alle</label>
                </span>
                <span class="btn btn-sm btn-outline-secondary" v-for="(label, key) in filters.available.type" v-bind:key="key">
                    <input type="radio" :value="key" v-model="filters.selected.type" :id="'filter-type-' + key" @change="getSorts()">
                    <label :for="'filter-type-' + key">{{ label }}</label>
                </span>
            </div>

            <div class="form-group btn-group btn-group-sm btn-group-toggle">
                <span class="btn btn-sm btn-outline-secondary" v-for="(label, key) in filters.available.atts" v-bind:key="key">
                    <input type="checkbox" :value="key" v-model="filters.selected.atts" :id="'filter-atts-' + key" @change="getSorts()">
                    <label :for="'filter-atts-' + key">{{ label }}</label>
                </span>
            </div>

            <div class="form-group btn-group btn-group-sm btn-group-toggle">
                <span class="btn btn-sm btn-outline-secondary">
                    <input type="radio" :value="null" v-model="filters.selected.alc" id="filter-alc-null" @change="getSorts()">
                    <label for="filter-alc-null">Alle</label>
                </span>
                <span class="btn btn-sm btn-outline-secondary" v-for="(label, key) in filters.available.alc" v-bind:key="key">
                    <input type="radio" :value="key" v-model="filters.selected.alc" :id="'filter-alc-' + key" @change="getSorts()">
                    <label :for="'filter-alc-' + key">{{ label }}</label>
                </span>
            </div>

        </div>

        <!-- <pre>{{ filters.selected }}</pre> -->
        <!-- <pre>{{ selectedFilters.join(', ') }}</pre> -->
        <!-- <pre>{{ filteredSorts.length }}</pre> -->

        <ul class="gridder" v-if="!loading">

            <li class="gridder-list" :data-griddercontent="'#content' + sort.id" v-for="sort in sorts" v-bind:key="sort.id">

                <div class="card card-square" :title="sort.title">

                    <img :src="sort.image.sizes.medium_large || fallback_image" class="card-img" :alt="sort.title">

                    <div class="card-img-overlay">
                        <h3 class="card-title">{{ sort.title }}</h3>
                    </div>

                    <!-- <div v-if="sort.message" class="sort-corner">
                        <span class="sort-message">{{ sort.message }}</span>
                    </div> -->

                </div>

            </li>

        </ul>

        <div :id="'content' + sort.id" class="gridder-content" v-for="sort in sorts" v-bind:key="sort.id">

            <div class="container">
                <div class="row">

                    <div class="col-md-12 d-none d-md-block">
                        <div class="sort-image">
                            <img :src="sort.image.sizes.large || fallback_image" :alt="sort.title" :title="sort.title">
                            <!-- <div v-if="sort.message" class="sort-corner">
                                <span class="sort-message">{{ sort.message }}</span>
                            </div> -->
                        </div>
                    </div>

                    <div class="col-md-12">

                        <header class="sort-header">
                            <h2 class="sort-title">{{ sort.title }}</h2>
                            <h3 class="sort-subtitle">{{ sort.subtitle }}</h3>
                        </header>

                        <div class="sort-content px-4" v-html="sort.content"></div>

                        <ul class="sort-attributes">
                            <li v-for="attr in sort.attributes" v-bind:key="attr">
                                <img
                                    :src="theme_url + '/assets/images/icon-' + attr + '.svg'"
                                    :alt="attr"
                                    :title="attr"
                                    width="48"
                                >
                                <span>{{ attr }}</span>
                            </li>
                        </ul>

                    </div>

                </div>
            </div>

        </div>

        <div v-if="loading" class="spinner-border text-secondary" role="status">
            <span class="sr-only">Loading...</span>
        </div>

    </div>
</template>

<script>
require('../../../node_modules/Gridder/src/jquery.gridder');

export default {
    data () {
        return {
            fallback_image: fallback_image,
            api_url: 'https://api.jackle-heidi.com/wp-json/v1/icesorts',
            theme_url: wp_theme_url,
            loading: true,
            filters: {
                available: {
                    type: {
                        becher: 'Bechereis',
                        stieleis: 'Stieleis',
                        hundeeis: 'Hundeeis',
                    },
                    atts: {
                        vegan: 'vegan',
                        glutenfrei: 'glutenfrei',
                        laktosefrei: 'laktosefrei',
                    },
                    alc: {
                        '0': 'ohne Alkohol',
                        '1': 'mit Alkohol',
                    },
                },
                selected: {
                    type: null,
                    atts: [],
                    alc:  null,
                }
            },
            // availableFilters: [],
            // selectedFilters: ['stieleis', 'mit-alkohol'],
            sorts: [],
        }
    },
    computed: {
        filteredSorts: function(){

            var $this = this;

            return $this.sorts.filter(function(sort) {

                if( $this.selectedFilters.length > 0 ) {

                    return sort.filters.some(function (filter) {

                        return $this.selectedFilters.indexOf(filter) >= 0;

                    });

                } else {

                    return sort;

                }

            });

        }
    },
    mounted() {

        this.getSorts();

    },
    methods: {

        getSorts: function() {

            var $this = this;

            $this.loading   = true;
            $this.sorts     = [];

            $.getJSON($this.api_url, $this.filters.selected, function(sorts){

                $this.sorts             = sorts.items;
                $this.availableFilters  = sorts.filters;
                $this.loading           = false;

                $this.$nextTick(function () {

                    $('.gridder').gridderExpander({
                        scrollOffset: 60,
                        animationSpeed: 250,
                        animationEasing: 'linear',
                        nextText: "Nächste Sorte",
                        prevText: "Vorherige Sorte",
                        closeText: "Schließen"
                    });

                });

            });

        }
    }
}
</script>
